import React from 'react';
import { Route } from 'react-router-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { connect } from 'react-redux';
//import Intercom, { shutdown } from '@intercom/messenger-js-sdk';

import Paper from 'material-ui/Paper';

import theme from '../../theme';

import './index.css';

// Define layout
class LoginLayout extends React.Component {
	render() {
//		shutdown() //this is to remove intercom
		const styles = {
			backgroundColor: '#F0F0F0'
		};
		return (
			<div className="login-wrapper">
				<Paper zDepth={5} style={styles}>
					{this.props.children}
				</Paper>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {};
};

const mapDispatchToProps = dispatch => {
	return {};
};

const ConnectedLayout = connect(
	mapStateToProps,
	mapDispatchToProps
)(LoginLayout);

export default ({ component: Component, ...rest }) => {
	return (
		<Route
			{...rest}
			render={matchProps => (
				<MuiThemeProvider muiTheme={theme}>
					<ConnectedLayout>
						<Component {...matchProps} />
					</ConnectedLayout>
				</MuiThemeProvider>
			)}
		/>
	);
};
